import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

export default function Settings() {
  const { user, loading, setUser } = useAuth();
  const navigate = useNavigate();
  const [displayName, setDisplayName] = useState("");
  const [bio, setBio] = useState("");
  const [avatar, setAvatar] = useState("");

  useEffect(() => {
    if (loading) return;
    if (!user) { navigate("/"); return; }
    setDisplayName(user.display_name || ""); setBio(user.bio || ""); setAvatar(user.avatar_url || "");
  }, [user, loading, navigate]);

  const saveProfile = async () => {
    const { data } = await api.patch("/users/me", { display_name: displayName, bio, avatar_url: avatar });
    setUser(data); toast.success("Profile saved");
  };

  if (!user) return null;
  return (
    <div className="max-w-lg mx-auto px-4 py-8">
      <h1 className="font-display text-3xl font-bold mb-6">Settings</h1>
      <div className="card-brutal p-5 bg-white space-y-3">
        <h2 className="font-display text-lg font-bold">Profile</h2>
        <div><label className="text-xs font-bold uppercase">Display name</label><Input data-testid="settings-displayname" value={displayName} onChange={(e) => setDisplayName(e.target.value)} className="border-2 border-ink mt-1" /></div>
        <div><label className="text-xs font-bold uppercase">Bio</label><Textarea data-testid="settings-bio" value={bio} onChange={(e) => setBio(e.target.value)} className="border-2 border-ink mt-1" rows={2} /></div>
        <div><label className="text-xs font-bold uppercase">Avatar URL</label><Input data-testid="settings-avatar" value={avatar} onChange={(e) => setAvatar(e.target.value)} className="border-2 border-ink mt-1" /></div>
        <button data-testid="save-settings-btn" onClick={saveProfile} className="h-11 px-5 border-2 border-ink bg-brand text-white font-bold btn-press shadow-brutal-sm">Save profile</button>
      </div>
      {/* Notification preferences are hidden until email notifications are wired up. */}
    </div>
  );
}
